import { FC, memo } from "react";
import Account from "ui/molecules/Account";
import Typography from "@mui/material/Typography";
import { useSettings } from "hooks";
import type { Settings } from "features/general/types";

type Props = {
    size?: number;
};

const Header: FC<Props> = ({ size }) => {
    const { getSettings } = useSettings<Settings>();
    const settings = getSettings();

    const commonSx = {
        fontFamily: 'var(--primary-font)'
    };

    return (
        <Account
            slotProps={{
                avatar: {
                    sx: {
                        width: size,
                        height: size
                    },
                    name: settings?.fullName,
                    alt: settings?.fullName
                }
            }}
        >
            <Typography
                sx={commonSx}
            >
                #{settings?.pki}
            </Typography>
            <Typography
                sx={{
                    ...commonSx,
                    fontWeight: 700
                }}
            >
                {settings?.fullName}
            </Typography>
        </Account>
    );
};

Header.defaultProps = {
    size: 82
};

export default memo(Header);
